import * as React from "react";
import type { SVGProps } from "react";
const SvgCopytradingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="copytrading_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M238.933 307.157a341.461 341.461 0 0 1 608.64 142.08 42.667 42.667 0 1 0 83.926-15.573C894.677 235.434 720.896 85.334 512 85.334a425.941 425.941 0 0 0-339.072 167.68l-3.157-18.945a42.667 42.667 0 0 0-84.182 14.08l20.822 124.416a42.667 42.667 0 0 0 49.109 35.072l124.459-20.821a42.667 42.667 0 1 0-14.08-84.181l-26.923 4.522zm-50.048 315.136a42.667 42.667 0 1 0-80.768 27.563C165.42 817.792 324.523 938.666 512 938.666c121.088 0 230.4-50.517 308.01-131.413l2.049 20.694a42.667 42.667 0 0 0 84.906-8.448l-12.501-125.867a42.667 42.667 0 0 0-46.72-38.23L721.92 667.948a42.667 42.667 0 1 0 8.448 84.906l26.027-2.56a341.504 341.504 0 0 1-567.51-128zm122.027 10.24a42.667 42.667 0 0 1-42.667-42.666A170.667 170.667 0 0 1 438.912 419.2a42.667 42.667 0 1 1 0 85.333 85.333 85.333 0 0 0-73.941 42.667h47.274l.256.341a42.667 42.667 0 0 1-5.589 84.95h-96zm170.667-282.709a58.667 58.667 0 1 1-117.334 0 58.667 58.667 0 0 1 117.334 0zm192 32a58.667 58.667 0 1 1-117.334 0 58.667 58.667 0 0 1 117.334 0zm-213.334 224a154.667 154.667 0 0 1 309.334 0v16a42.667 42.667 0 0 1-42.667 42.667h-224a42.667 42.667 0 0 1-42.667-42.667v-15.957zm218.667-26.667a69.376 69.376 0 0 0-128 0h128z"
    />
  </svg>
);
export default SvgCopytradingIcon;
